var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94085 8.90283L2.17969 13.673L3.24135 14.7327L8.00051 9.96449L12.7597 14.7327L13.8213 13.673L9.06017 8.90283L13.8213 4.13266L12.7597 3.073L8.00051 7.84116L3.24135 3.073L2.17969 4.13266L6.94085 8.90283Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossS);
export default __webpack_public_path__ + "static/media/cross-S.f327c2c8859adf7909d1a815939c7f6b.svg";
export { ForwardRef as ReactComponent };